import { useSelector } from 'react-redux';

import type {
  MediaItem,
  ProductMediaState,
} from 'src/components/organisms/ProductMediaCarousel/types';
import { selectProductMedia } from 'src/redux/product/selectors';
import {
  selectCurrentMedia,
  selectIsModalOpen,
  selectNavigatedBy,
} from 'src/redux/productMediaCarousel/selectors';

/**
 * View model for the full-screen media modal. Owns the reads for what the modal
 * shows and whether it is open, so the modal takes props and its interaction
 * handlers come from useProductMediaModalActions alongside.
 *
 * The media list and current index are the same state the carousel reads, which is
 * what keeps the two in step: opening the modal on the third image shows the third
 * image, and navigating in the modal leaves the carousel on the media you stopped on.
 * `navigatedBy` comes along because the modal's own swipe track projects state back
 * onto its scroll position, and how it was navigated decides whether that fades or snaps.
 */
export interface ProductMediaModalViewModel {
  currentMedia: ProductMediaState['currentMedia'];
  isModalOpen: ProductMediaState['isModalOpen'];
  media: MediaItem[];
  navigatedBy: ProductMediaState['navigatedBy'];
}

export const useProductMediaModalViewModel = (): ProductMediaModalViewModel => ({
  currentMedia: useSelector(selectCurrentMedia),
  isModalOpen: useSelector(selectIsModalOpen),
  media: useSelector(selectProductMedia),
  navigatedBy: useSelector(selectNavigatedBy),
});
